import { productCompareFlyOutStyles } from "@insite/content-library/Components/ProductCompareFlyOut";
import Drawer, { DrawerPresentationProps, DrawerProps } from "@insite/mobius/Drawer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer!.cssOverrides = {
    scrim: css`
        border: 1px solid #cccccc;
        width: 50%;
        margin: auto;
        box-shadow: rgb(102 102 102) 3px 10px 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 70%;
                `,
                css`
                    width: 70%;
                `,
                css`
                    width: 70%;
                `,
                css`
                    width: 50%;
                `,
            ])}
    `,
    drawerBody: css`
        ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [null, null, null, null, null])};
        position: absolute;
    `,
    drawerTitle: css`
        background: ${getColor("common.accent")};
        color: ${getContrastColor("common.accent")};
        padding-left: 5px;
    `,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        > div[data-test-selector="carousel_gridContainer"] {
            > div[class^="GridOffset"] {
                &:first-child {
                    [data-test-selector="slides"] {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                css`
                                    width: 66%;
                                `,
                                null,
                                null,
                                null,
                            ])}
                        div[data-test-selector="slideContainer"] {
                            padding: 0 10px;
                        }
                    }
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: none;
                    `,
                ],
                "max",
            )}
    `,
};
productCompareFlyOutStyles.headerRemoveAllButton = {
    css: css`
        margin: 5px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    padding: 10px;
                `,
                null,
                null,
                null,
            ])}
    `,
    variant: "secondary",
};
productCompareFlyOutStyles.headerCompareButton = {
    css: css`
        margin: 5px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    padding: 10px;
                `,
                null,
                null,
                null,
            ])}
    `,
};
